import axios from "axios";

const Fetch = axios.create();

Fetch.interceptors.request.use(
	(request) => {
		request.headers["Content-Type"] = "application/json";
		request.headers["Authorization"] = window["getUserDetails"]
			? (token + window["getUserDetails"]().legacyJWT)
			: token; // todo

		return request;
	},
	(error) => {
		return Promise.reject(error);
	}
);

Fetch.interceptors.response.use(
	(response) => response,
	(error) => {
		const { status, responseText } = error.request;
		if (status === 401) {
			console.error("Request Failued due to :", responseText);
			return false;
		}
		return Promise.reject(error);
	}
);

export default Fetch;

const token = "Bearer ";
